import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: '/',
    routes: [
        {
            path: '/',
            redirect: '/chat'
        },
        {
            path: '/main',
            name: 'Main',
            component: r => require.ensure([], () => r(require('@/pages/index.vue')), 'Main')
        },
        {
            path: '/login',
            name: 'Login',
            component: r => require.ensure([], () => r(require('@/pages/login.vue')), 'Login')
        },{
            path: '/agreement',
            name: 'Agreement',
            component: r => require.ensure([], () => r(require('@/pages/agreement.vue')), 'Agreement')
        },
        {
            path: '/chat',
            name: 'Chat',
            component: r => require.ensure([], () => r(require('@/pages/chat/main.vue')), 'Chat')
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js